import React, { useState } from 'react';
import useFetchData from '../getJobs';
export const Context = React.createContext();



const Provider = props => {
    const [jobParams, setJobParams] = useState(0); //job params for search
    const {data, loading} = useFetchData(jobParams); 
    const [pageIndex, setPageIndex] = useState(1);  //sets the page num that the user is on


    return (
      <Context.Provider
        value={{
          data,
          loading,
          jobParams,
          pageIndex,
          updateJobParams: jobParams => setJobParams(jobParams),
          updatePageIndex: pageIndex => setPageIndex(pageIndex)
        }}
      >
        {props.children}
      </Context.Provider>
    );
  };
  
  export default Provider;
